import {
  RESET_FORM_SUBMIT,
  RESET_FORM_SUCCESS,
  RESET_FORM_ERROR,
  RESET_FORM_STATE,
  SUBMIT_SELECTED_CONTACT,
  SELECTED_CONTACT_SUCCESS,
  SELECTED_CONTACT_ERROR,
  SUBMIT_OTP_REQUEST,
  SUBMIT_OTP_SUCCESS,
  SUBMIT_OTP_ERROR,
  SUBMIT_UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_ERROR,
  UPDATE_SUBMIT_OTP_STEP,
  RESET_ERROR_STATE,
  PERIMETER_ENABLED,
  GEORGE_RESET_PASSWORD_DISRUPTED,
} from '../actions/constants'
import { getDefaultValues } from '../../../utils/common'
import { GEORGE_PASSWORD_DISRUPTED_MSG } from '../../../utils/constants/validations'

const defaultState = {
  email: getDefaultValues()[0],
  step: getDefaultValues()[1],
  contacts: '',
  fromEmailLink: '',
  error: null,
  errorCode: null,
  errorDescription: null,
  isPerimeterXEnabled: false,
  noSuchUserError: false,
}
export default (state = defaultState, action) => {
  switch (action.type) {
    case RESET_FORM_SUBMIT:
      return { ...state, isLoading: true }
    case RESET_FORM_SUCCESS:
      return {
        ...state,
        email: action.response.email,
        step: action.response.step,
        isLoading: false,
        error: null,
        ...action.response,
      }
    case RESET_FORM_ERROR:
      return {
        ...state,
        isLoading: false,
        step: action.step,
        email: action.response.email,
        noSuchUserError: true,
        isPerimeterXEnabled: false,
      }
    case RESET_FORM_STATE:
      return {
        ...defaultState,
        email: '',
        step: 'ENTER_EMAIL',
      }
    case SUBMIT_SELECTED_CONTACT:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SELECTED_CONTACT_SUCCESS:
      return {
        ...state,
        email: action.response.email,
        step: action.response.step,
        isLoading: false,
        error: null,
        selectedContacts: action.selectedContacts,
        ...action.response,
      }
    case SELECTED_CONTACT_ERROR:
      return {
        ...state,
        isLoading: false,
        ...action.response,
      }
    case SUBMIT_OTP_REQUEST:
      return { ...state, isLoading: true }
    case SUBMIT_OTP_SUCCESS:
      return {
        ...state,
        email: action.response.email,
        step: action.response.step,
        isLoading: false,
        error: null,
        ...action.response,
      }
    case SUBMIT_OTP_ERROR:
      return {
        ...state,
        errorCode: action.response.errorCode,
        errorDescription: action.response.errorDescription,
        error: true,
      }
    case UPDATE_SUBMIT_OTP_STEP:
      return {
        ...state,
        isLoading: false,
        step: action.step,
        selectedContacts: action.selectedContacts,
      }
    case RESET_ERROR_STATE:
      return {
        ...state,
        isLoading: false,
        error: null,
        errorDescription: null,
        errorCode: null,
      }
    case SUBMIT_UPDATE_PASSWORD:
      return { ...state, isLoading: true }
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        email: action.response.email,
        step: action.response.step,
        isLoading: false,
        resetCode: action.response.resetCode,
        error: null,
        ...action.response,
      }
    case UPDATE_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        errorCode: action.response.errorCode,
        errorDescription: action.response.errorDescription,
        error: true,
      }
    case PERIMETER_ENABLED:
      return {
        ...state,
        isPerimeterXEnabled: true,
        ...action.response,
        email: action.formData.email,
      }
    case GEORGE_RESET_PASSWORD_DISRUPTED:
      return {
        ...state,
        isLoading: false,
        isGeorgeResetPasswordDisrupted: true,
        error: true,
        errorDescription: GEORGE_PASSWORD_DISRUPTED_MSG,
      }
    default:
      return state
  }
}
